import React, { useState } from 'react';
import { toast } from 'sonner';
import Widget from './Widget';
import PendingOrders from '../PendingOrders';
import ConfirmModal from '../ui/ConfirmModal';
import { useAccountData } from '../../context/AccountDataProvider';
import { cancelPendingOrder } from '../../api/api';

const PendingOrdersWidget = ({ hideTitle = false }) => {
  const { pendingOrders } = useAccountData();
  const [confirmOrderId, setConfirmOrderId] = useState(null);
  const [loadingOrderId, setLoadingOrderId] = useState(null);

  const handleCancelOrder = (orderId) => {
    if (!orderId) return;
    setConfirmOrderId(orderId);
  };

  const executeCancelOrder = async () => {
    if (!confirmOrderId) return;
    setLoadingOrderId(confirmOrderId);
    try {
      await cancelPendingOrder(confirmOrderId);
      toast.success('Order cancelled successfully');
      setConfirmOrderId(null);
    } catch (err) {
      const detail = err?.response?.data?.detail || err?.response?.data?.error || err?.message;
      toast.error(detail ? `Failed to cancel order. ${detail}` : 'Failed to cancel order.');
    } finally {
      setLoadingOrderId(null);
    }
  };

  return (
    <Widget title="Pending Orders" className="w-full" hideTitle={hideTitle}>
      <PendingOrders
        bare
        pendingOrders={pendingOrders}
        cancelOrder={handleCancelOrder}
        loadingOrderId={loadingOrderId}
      />

      <ConfirmModal
        open={!!confirmOrderId}
        onClose={() => !loadingOrderId && setConfirmOrderId(null)}
        onConfirm={executeCancelOrder}
        loading={!!loadingOrderId}
        title="Cancel Order"
        message="Are you sure you want to cancel this pending order?"
        confirmLabel="Cancel Order"
        confirmVariant="danger"
      />
    </Widget>
  );
};

export default PendingOrdersWidget;
